"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var metricsReporterProvider = function () {
    function metricsReporterProvider() {
        var _this = this;

        _classCallCheck(this, metricsReporterProvider);

        this._validateInitialization = function () {
            if (!_this.isInitialized) {
                throw new Error("monitor client hasn't been initialized");
            }
        };

        this.sendMeasure = function (name, value, id) {
            _this._validateInitialization();

            _this.onMeasure && _this.onMeasure(name, value, id);
        };

        this.sendOccurrence = function (name) {
            _this._validateInitialization();

            _this.onOccurrence && _this.onOccurrence(name);
        };

        this.isInitialized = false;
    }

    _createClass(metricsReporterProvider, [{
        key: "_initialize",
        value: function _initialize(onMeasure, onOccurrence) {
            this.isInitialized = true;
            this.onMeasure = onMeasure;
            this.onOccurrence = onOccurrence;
        }
    }]);

    return metricsReporterProvider;
}();

var provider = new metricsReporterProvider();

var init = function init(config) {
    provider._initialize(config.onMeasure, config.onOccurrence);
};

exports.default = provider;

module.exports.initMetricsReporter = init;